export default class EditableImage {
    static init() {
        document.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;

            if (target.classList.contains('editable-image-wrapper')) {
                e.preventDefault();
                this.handleInput(target);
            } else {
                const parent = target.parentElement;
                if (parent && parent.classList.contains('editable-image-wrapper')) {
                    e.preventDefault();
                    this.handleInput(parent);
                }
            }
        });
    }

    static handleInput(element: HTMLElement) {
        const input = element.querySelector('.editable-image-input') as HTMLInputElement;
        if (input) {
            input.click();
        }

        input.addEventListener('change', () => {
            const form = element.querySelector('form') as HTMLFormElement;
            const submit = element.querySelector('button[type="submit"]') as HTMLButtonElement;
            if (form && submit) {
                submit.click();
            }
        });
    }
};
